<template>
  <div class="matches-page">
    <m-widget-head class="matches-head" style="background-image: linear-gradient(to top right,#713592,#342d6e) !important;">
      <active-button
        style="color: white;"
        :active="isActive('view', 'prematch')"
        @click="$router.push('/favorites/prematch')"
      >
        Prematch
      </active-button>
      <active-button
        style="color: white;"
        :active="isActive('view', 'live')"
        @click="$router.push('/favorites/live')"
      >
        Live
      </active-button>
      <template slot="right">
        <m-button style="color: white;" @click="clearAll">{{ $t('favorites.clear-all') }}</m-button>
      </template>
    </m-widget-head>
    <router-view />
  </div>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MButton from '@/components/buttons/MButton'
import ActiveButton from '@/components/buttons/ActiveButton'

export default {
  components: {
    MLayoutMask,
    MWidgetHead,
    MButton,
    ActiveButton
  },
  methods: {
    clearAll () {
      this.$store.commit('favorites/CLEAR')
      let scrollbar = document.querySelector('#favorite-overview-scrollbar')
      if (!scrollbar) return
      scrollbar.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.matches-page { height: 100%; }
.matches-head { background: #263238; margin: 0 10px; position: relative; z-index: 1; }
.m-button { height: 40px; line-height: 40px; padding: 0 10px; }
</style>



// WEBPACK FOOTER //
// src/components/favorites/Favorites.vue